import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';

export const saveFulfillmentPlan = (shippingConfig) => {
  const request = axios.post('fulfillmentPlan/rateBrowser', shippingConfig).then((response) => {
    return get(response, 'data.fulfillmentPlanId');
  });

  const data$ = from(request);
  return data$;
};
